<template lang="html">
  <div class="cancel-invite">
    <transition name="fade" mode="out-in">
      <div
        class="cancel__request"
        v-if="!cancelRequested"
        @click="cancelInvitationHandler"
        key="requestCancel"
      >
        Cancel Invitation
      </div>
      <div class="cancel__verify" v-else key="verifyCancel">
        <div class="cancel__no" @click="cancelInvitationHandler">No</div>
        <div class="cancel__confirm" @click="cancelInvitationHandler">
          Yes, Cancel
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: "CancelButton",
  props: {
    notification: Object,
  },
  data() {
    return {
      // buttonState: 'requestCancel'
      cancelRequested: false,
      // cancelConfirmed: false
    };
  },
  computed: {},
  methods: {
    ...mapActions(['api/nav/cancelRoomInvite', 'popups/show/error/custom']),
    async cancelInvitationHandler(e) {
      const buttonName = e.target.className

      if (buttonName === "cancel__request") {
        this.cancelRequested = true
      }
      if (buttonName === "cancel__no") {
        this.cancelRequested = false
      }
      if (buttonName === "cancel__confirm") {
        let res = await this['api/nav/cancelRoomInvite'](this.notification)
        if(!res?.success) this['popups/show/error/custom']('cancelling the invite')
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/scss/components/notifications/cancel_button.scss";
</style>
